type Props = {
  size?: number;
  thickness?: number;
  color?: string;
};

const SIZE = 44;

const CircularProgress = ({
  size = 24,
  thickness = 4,
  color = '#fff',
}: Props) => {
  const sizeProps = { width: size, height: size };
  return (
    <svg viewBox={`${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`} {...sizeProps}>
      <circle
        style={{
          strokeDasharray: '80px, 200px',
          strokeDashoffset: 0,
          transformOrigin: '100% 100%',
        }}
        cx={SIZE}
        cy={SIZE}
        r={(SIZE - (thickness + 5)) / 2}
        fill="none"
        strokeWidth={thickness}
        stroke={color}
      >
        <animateTransform
          from="0 0 0"
          to="360 0 0"
          attributeName="transform"
          type="rotate"
          repeatCount="indefinite"
          dur="1300ms"
        />
      </circle>
    </svg>
  );
};

export default CircularProgress;
